
















































































































import Spinner from 'vue-simple-spinner';
import VueSlider from 'vue-slider-component';
import Vue from 'vue';
import { DateTime } from 'luxon';
import episodesThroughLens from './episodesThroughLens'
import EditorEpisodeList from '../components/EditorEpisodeList.vue'
import EditorOutputSummary from '../components/EditorOutputSummary.vue'
import EditorBottomTiles from '../components/EditorBottomTiles.vue'
const numberOfMillisInOneYear = 365 * 24 * 60 * 60 * 1000;
export default Vue.extend({
  name: 'EditorStage2',
  components: { Spinner, VueSlider, EditorEpisodeList, EditorOutputSummary, EditorBottomTiles },
  props: {
    feedData: {
      type: Object,
      default: null,
    },
    publicID: {
      type: String,
      default: ''
    },
    privateID: {
      type: String,
      default: null
    },
    sourceData: {
      type: Object,
      default: null
    },
    loadedPodpastSettings: {
      type: Object,
      default: null
    }
  },
  data(): {
    timeNowMillis: number;
    initialTimeMS: number;
    startTimeMS: number;
    speedup: number;
    clickedEpisode: any | null;
    draggingItem: any;
  } {
    const timeNowMillis = new Date(new Date().getTime()).getTime()
    return {
      timeNowMillis,
      speedup: 1,
      clickedEpisode: null,
      draggingItem: null,
      initialTimeMS: this.feedData.earliestEpisodeMillis,
      startTimeMS: timeNowMillis,
    };
  },
  computed: {
    episodesThroughLens,
    sliderMarks(): number[] {
      return this.feedData.episodes
        .filter((item: any, index: number) => {
          return index < 10
        })
        .map((episode: any) => {
          return episode.dateTimeMillis
        })
    },
    friendlyVersionOfInitialTime(): string {
      return DateTime.fromMillis(this.initialTimeMS).toLocaleString()
    },
    numberOfIncludedEpisodes(): number {
      return this.episodesThroughLens
        .filter((episode) => {
          return !episode.tooOld
        })
        .length
    },
    numberOfRecastEpisodesAvailableNow(): number {
      const timeNow = Date.now()
      return this.episodesThroughLens
        .filter((episode) => {
          return !episode.tooOld && episode.newDateTime && episode.newDateTime.ts < timeNow
        })
        .length
    },
    timeMSUntilNextRecast(): number | null {
      const timeNow = Date.now()
      const included = this.episodesThroughLens
        .filter((episode) => {
          return !episode.tooOld //  && episode.newDateTime.ts < timeNow
        })
      if (included.length > this.numberOfRecastEpisodesAvailableNow &&
        included[(included.length - this.numberOfRecastEpisodesAvailableNow)]
      ) {
        return timeNow - included[(included.length - this.numberOfRecastEpisodesAvailableNow)]
          .newDateTime.ts // Not sure if this is right
      } else {
        return null
      }
    },
    timeDaysUntilNextRecast(): number | null {
      if (this.timeMSUntilNextRecast) {
        return Math.round(this.timeMSUntilNextRecast / 1000 / 60 / 60 / 24)
      } else {
        return null
      }
    },
    podpastSettings(): any {
      return {
        initialTimeMS: this.initialTimeMS,
        startTimeMS: this.startTimeMS,
        speedup: this.speedup
      }
    }
  },
  watch: {
    loadedPodpastSettings: {
      immediate: true,
      handler(loadedPodpastSettings: any) {
        if (loadedPodpastSettings) {
          this.initialTimeMS = loadedPodpastSettings.initialTimeMS
          this.startTimeMS = loadedPodpastSettings.startTimeMS
          this.speedup = loadedPodpastSettings.speedup
        }
      }
    }
  },
  methods: {
    initialFromEpisode(episode: any) {
      this.initialTimeMS = episode.dateTimeMillis;
    },
    toLocaleStringFormatter(millis: number) {
      const dateTime = DateTime.fromMillis(millis)
      return dateTime.toLocaleString()
    },
    onStartTimeChange(value: number) {
      if (value < this.initialTimeMS) {
        const initialTimeSlider: any = this.$refs.initialTimeSlider
        if (initialTimeSlider && initialTimeSlider.setValue) {
          initialTimeSlider.setValue(this.initialTimeMS) // Basically block it from being less than the other one
        }
        // TODO Maybe inform why this is happening
      }
    },
    receiveUpdatedPodpastSettings(podpastSettings: any) {
      this.initialTimeMS = podpastSettings.initialTimeMS
      this.startTimeMS = podpastSettings.startTimeMS
      this.speedup = podpastSettings.speedup
    }
  },
});
